import Store from '@/base/constants/Store'
import {
  generateCountryCode,
  generateImageUrl,
  generateParagraph,
  generateProductName,
  generateSentence,
  generateUrl,
  generateUuid,
  getRandomFloat,
  getRandomFutureDate,
} from '../utils/randomizer'

export const inAppEventsRoutes = {
  'POST /in-app-events/:store': (params, config) => {
    const { store } = params
    const { countries = ['US'] } = config.params
    let trackIds = JSON.parse(config.data)
    if (!Array.isArray(trackIds) || !trackIds.length)
      throw new Error('Missing trackId list')

    trackIds = trackIds.length > 5 ? trackIds : Array.from({ length: 5 }, () => getRandomFloat(10_0000, 90_0000, 0))

    const events = trackIds.map(trackId => ({
      trackId,
      eventId: getRandomFloat(10_0000, 90_0000, 0),
      url: generateUrl(),
      image: {
        hashNull: true,
        hashV2Null: true,
        url: generateImageUrl(),
        thumbnailUrl: generateImageUrl(),
      },
      name: generateProductName(),
      subtitle: generateSentence(),
      kind: 'CHALLENGE',
      badgeKind: 'happening',
      description: generateParagraph(),
      startDate: getRandomFutureDate().toISOString(),
      endDate: getRandomFutureDate().toISOString(),
      id: generateUuid(),
      country: generateCountryCode(),
    }))

    return {
      success: true,
      data: store == Store.Ios
        ? countries.reduce((acc, countryCode) => {
            acc[countryCode] = events
            return acc
          }, {})
        : events,
    }
  },
}
